import UserDetailPage from "@/app/(app)/(crew)/home/[shift]/user/[user]";
export default UserDetailPage;
